export function area(state) {
  return state.area;
}
